import { Injectable, Pipe, PipeTransform, inject } from '@angular/core';
import { AssetDto, AssetSearchDto } from '@nusign/picflow-backend-types';
import { canDisplayAsset } from '../../lib/can-display-asset';
import { AssetVersionUrlPipe } from './asset-version-url.pipe';
import { FailedAssetVersionUrlPipe } from './failed-asset-version-url.pipe';

@Pipe({
  name: 'assetUrl',
  standalone: true,
})
@Injectable({
  providedIn: 'root',
})
export class AssetUrlPipe implements PipeTransform {
  private versionPipe = inject(AssetVersionUrlPipe);
  private failedVersionPipe = inject(FailedAssetVersionUrlPipe);

  transform(
    asset: AssetDto | AssetSearchDto,
    watermark_uuid: string,
    width: number,
    allowLowRes = false,
    halfQuality = false,
    allowDouble = true,
    allowUpScale = true
  ): string {
    if (!asset?.version_data || !canDisplayAsset(asset)) {
      return '';
    }

    if (!asset?.version_data) return '';
    return this.versionPipe.transform(
      asset.version_data,
      asset.version_data.uuid,
      asset.version_data['status'],
      asset.version_data.watermark_uuid,
      width,
      allowLowRes,
      asset.watermark_enabled,
      halfQuality,
      allowDouble,
      false,
      allowUpScale
    );
  }
}
